import { Col } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledCurrencyCol = styled(Col)`
  display: flex;
  gap: 0.25rem;
`;
